import { render, staticRenderFns } from "./ClubsSummary2.vue?vue&type=template&id=136b7160&scoped=true"
import script from "./ClubsSummary2.vue?vue&type=script&lang=js"
export * from "./ClubsSummary2.vue?vue&type=script&lang=js"
import style0 from "./ClubsSummary2.vue?vue&type=style&index=0&id=136b7160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b7160",
  null
  
)

export default component.exports